import { render, staticRenderFns } from "./recently_courses.vue?vue&type=template&id=5ee44b46&scoped=true&"
import script from "./recently_courses.vue?vue&type=script&lang=js&"
export * from "./recently_courses.vue?vue&type=script&lang=js&"
import style0 from "./recently_courses.vue?vue&type=style&index=0&id=5ee44b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee44b46",
  null
  
)

export default component.exports